"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorSubForm = void 0;
var tslib_1 = require("tslib");
var form_palette_1 = require("../form.palette");
var form_field_editor_1 = require("./form.field.editor");
var form_field_tree_view_1 = require("./form.field.tree.view");
var FormFieldEditorSubForm = /** @class */ (function (_super) {
    tslib_1.__extends(FormFieldEditorSubForm, _super);
    function FormFieldEditorSubForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormFieldEditorSubForm.prototype.viewTree = function () {
        return form_field_tree_view_1.FormFieldTreeView.viewForm(this);
    };
    FormFieldEditorSubForm.prototype.viewInfoRW = function () {
        var _this = this;
        return form_palette_1.FormDesignerPalette.view(function (type) { return _this.designer.createField(_this.field, type); }, this.depth);
    };
    return FormFieldEditorSubForm;
}(form_field_editor_1.FormFieldEditor));
exports.FormFieldEditorSubForm = FormFieldEditorSubForm;
//# sourceMappingURL=form.field.editor.subform.js.map